import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var styles = {"buttonTileGroupWrapper":"buttonTileGroupWrapper-1jO28","buttonTileGroupTitle":"buttonTileGroupTitle-1jO28","buttonTileGroupFieldset":"buttonTileGroupFieldset-1jO28"};

var _excluded = ["children", "className", "eventAttribute", "id", "label", "onSelectCallback", "selectedIndex", "wrapperComponent"];
var ButtonTileGroup = /*#__PURE__*/forwardRef((_ref, ref
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  var {
      children,
      className,
      eventAttribute,
      id,
      label,
      onSelectCallback,
      selectedIndex,
      wrapperComponent
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var buttonTilesRef = [];
  var onChangeSelection = index => onSelectCallback instanceof Function ? onSelectCallback(index) : false;
  var handleKeyDown = (event, index) => {
    var groupLength = children.length;
    switch (event.which) {
      case 32:
        {
          // space
          event.preventDefault();
          // spacebar should check if not checked
          onChangeSelection(index);
          break;
        }
      case 40:
      case 39:
        {
          event.preventDefault();
          // right arrow
          var newIndex = index + 1;
          if (newIndex >= groupLength) {
            // loop back to beginning
            newIndex = 0;
          }
          onChangeSelection(newIndex);
          buttonTilesRef[newIndex].focus();
          break;
        }
      case 38:
      case 37:
        {
          event.preventDefault();
          // left arrow
          var _newIndex = index - 1;
          if (_newIndex < 0) {
            // loop back to end
            _newIndex = groupLength - 1;
          }
          onChangeSelection(_newIndex);
          buttonTilesRef[_newIndex].focus();
          break;
        }
      default:
        return true;
    }
    return true;
  };
  var clonedChildren = React.Children.map(children, (child, index) => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      eventAttribute,
      handleKeyDown,
      index,
      isSelected: selectedIndex === index,
      onChangeSelection,
      ref: node => {
        buttonTilesRef[index] = node;
      },
      selectedIndex
    }) : null;
  });
  return /*#__PURE__*/React.createElement("fieldset", {
    "data-testid": "button-tile-group",
    className: styles.buttonTileGroupFieldset
  }, label && /*#__PURE__*/React.createElement("legend", {
    id: id,
    className: styles.buttonTileGroupTitle,
    "data-testid": "button-tile-group__label"
  }, label), /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "button-tile-group__group",
    className: cs({
      [className]: className
    }),
    role: "radiogroup",
    ref: ref
  }, otherProps), wrapperComponent(clonedChildren)));
});
var propTypes = {
  /** Expects ButtonTile components to be passed as children */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /** Specify which event attributes should trigger selection on the radio button; can pass multiple values separated by a space */
  eventAttribute: PropTypes.string,
  /** id attribute to be used on the label; do not specify if 'label' is omitted */
  id: PropTypes.string,
  /** Specify title text for this radio group; */
  label: PropTypes.string,
  /** Callback to be triggered when a selection is made */
  onSelectCallback: PropTypes.func,
  /** Index of the currently selected radio button in the group */
  selectedIndex: PropTypes.number,
  /** Specify an optional component to wrap the radio buttons, such as a carousel */
  wrapperComponent: PropTypes.func
};
var defaultProps = {
  className: '',
  eventAttribute: 'onClick',
  id: 'button-tile-group-label',
  label: '',
  selectedIndex: -1,
  onSelectCallback: () => {},
  wrapperComponent: childrenArg => /*#__PURE__*/React.createElement("div", {
    "data-testid": "button-tile-group__component_wrapper",
    className: styles.buttonTileGroupWrapper
  }, childrenArg)
};
ButtonTileGroup.propTypes = propTypes;
ButtonTileGroup.defaultProps = defaultProps;

export { ButtonTileGroup, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
